var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaratUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8499 16.0349L12.4099 9.59488C12.2099 9.39488 11.8999 9.39488 11.6999 9.59488L5.26995 16.0349C5.17995 16.1249 5.04995 16.1849 4.91995 16.1849H3.49995C3.04995 16.1849 2.82995 15.6449 3.14995 15.3349L11.7099 6.77488C11.9099 6.57488 12.2199 6.57488 12.4199 6.77488L20.9799 15.3349C21.2899 15.6449 21.0699 16.1849 20.6299 16.1849H19.2199C19.0899 16.1849 18.9599 16.1349 18.8699 16.0349H18.8499Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaratUp);
export default __webpack_public_path__ + "static/media/CaratUp.f948ef70d0726992cd0faf47ffe90e80.svg";
export { ForwardRef as ReactComponent };